import { useQuery } from '@apollo/client/react'
import {
  PortalDeliveryChannelsDocument,
  type PortalDeliveryChannelsQuery,
} from '@/graphql/generated/graphql'

export type DeliveryChannel =
  PortalDeliveryChannelsQuery['portalDeliveryChannels'][number]

/** Catálogo de canales de entrega disponibles para comprar crédito. */
export function useDeliveryChannels() {
  const { data, loading, error } = useQuery(PortalDeliveryChannelsDocument, {
    fetchPolicy: 'cache-first',
  })

  return {
    channels: data?.portalDeliveryChannels ?? [],
    loading,
    error,
  }
}
